import React from "react";
import { Button, Row, Col, Card, Image } from "react-bootstrap";
import "../Common/Common.css";
import { Formik, Form } from "formik";
import { TextField } from "../Common/FormikTemplates/TextField";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import "./login.css";
const reg =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

const Login = (props) => {
  const validate = Yup.object({
    UserID: Yup.string()
      .matches(reg, " Enter a valid email")
      .required("Email is required"),
    password: Yup.string()
      .min(6, "Password must be atleast 6 characters long")
      .required("Password is required"),
  });

  return (
    <div>
      <div className="bgcolorLogin">
        <Row>
          <Col xs={12} md={6} sm={12} lg={6}>
            <img
              className="loginfrstImg"
              src={require("../../assets/img/login-image.png")}
              alt=""
            />
          </Col>
          <Col xs={12} md={6} sm={12} lg={6}>
            <div className="logindiv">
              <div>
                <img
                  className="loginimage"
                  src={require("../../assets/img/logisrannurLogo.png")}
                />
              </div>
              <div>
                <h3 className="loginrydz">Hello! let's get started</h3>
              </div>
              <div>
                <p className="docdroppera">Please sign-in to your account.</p>
              </div>

              <div className="loginForm">
                <Formik
                  initialValues={{
                    UserID: "",
                    password: "",
                  }}
                  validationSchema={validate}
                  onSubmit={(value) => {
                    props.logins(value);
                  }}
                >
                  {(formik) => (
                    <div>
                      <div>
                        <Form className="loginform">
                          <Row>
                            <Col lg={12} md={12} sm={12} xs={12}>
                              <div>
                                <TextField
                                  label="Email"
                                  name="UserID"
                                  type="text"
                                  isRequired={true}
                                />
                              </div>
                              <div>
                                <TextField
                                  label="Password"
                                  name="password"
                                  type="password"
                                  isRequired={true}
                                />
                              </div>
                            </Col>
                          </Row>
                          <div>
                            <Link
                              to="/forgotpassword"
                              className="loginforgot"
                              // onClick={() => window.scrollTo(0, 0)}
                            >
                              Forgot your Password ?
                            </Link>
                          </div>

                          <Button type="submit" className="contactpagebtn">
                            Sign in
                          </Button>

                          <div className="loginaccount">
                            Don't have an account?
                            <span className="loginaccounts">
                              <Link to="/signup" className="loginaccounts">
                                Create an account
                              </Link>
                            </span>
                          </div>
                        </Form>
                      </div>
                    </div>
                  )}
                </Formik>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Login;
